import { cn } from '~/shadcn/lib/utils'
import { LabelValueItem } from './LabelValueItem'

type Props = {
  items: { label: string; value: React.ReactNode | string }[]
  className?: string
  itemClassName?: string
}

function LabelValueList({ items, className, itemClassName }: Props) {
  return (
    <div className={cn('flex flex-col gap-3 lg:gap-1', className)}>
      {items.map(({ label, value }) => (
        <LabelValueItem
          key={`LabelValueList-${label}`}
          label={label}
          value={value}
          className={itemClassName}
          labelClassName="text-sm font-semibold uppercase"
          contentClassName="font-semibold"
        />
      ))}
    </div>
  )
}

export { LabelValueList }
